import { render } from "./tourView.vue?vue&type=template&id=66dbcec4"
import script from "./tourView.vue?vue&type=script&lang=js"
export * from "./tourView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__